import * as actions from './Actions.js';

import {
  PARAM_EXIBE_DADOS_IMOVEIS_OBRAS,
  PARAM_EXIBE_OBRAS_NUMERO_SEI,
  PARAM_PLANILHASOBRAS
} from 'portaltransparencia-common/parametros/ParametrosPortalTransparencia';
import {
  findEmpenhoLiquidacoesDocumentosMultiplos,
  findEmpenhoLiquidacoesMultipla,
  resetLiquidacoesDocumentosMultiplos,
  resetLiquidacoesMultipla
} from '../empenhos/Actions.js';

import BotaoImprimir from 'portaltransparencia-common/components/BotaoImprimir.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import Tab from 'portaltransparencia-common/components/Tab.react.js';
import Tabs from 'portaltransparencia-common/components/Tabs.react.js';
import { getValueFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import { downloadArquivo } from '../arquivo/Actions.js';
import PageHeader from '../components/PageHeader.react.js';
import EmpenhoDetalheLiquidacoes from '../empenhos/FormDetalheLiquidacao.react.js';
import EmpenhoDetalheLiquidacoesDocumentos from '../empenhos/FormDetalheLiquidacaoDocumentos.react.js';
import CabecalhoEntidade from '../entidades/CabecalhoEntidade.react.js';
import ParametroService from '../parametros/ParametroService.js';
import { ObraDetalheEmpenho } from './ObraDetalheEmpenho.react.js';
import ObraDetalheInformacao from './ObraDetalheInformacao.react.js';
import ObraDetalheMedicao from './ObraDetalheMedicao.react.js';
import ObraDetalhePlanilha from './ObraDetalhePlanilha.react.js';
import ObraFonteRecurso from './ObraFonteRecurso.react.js';
import ObraOrdemServicoArquivo from './ObraOrdemServicoArquivo.react.js';
import ObraDetalheResponsavel from './ObraDetalheResponsavel.react.js';
import ObraDetalheImovel from './ObraDetalheImovel.react.js';
import { fromJS } from 'immutable';
import { Link } from 'react-bootstrap/lib/Navbar.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';
import { findAllContratosByIntervencao } from '../service/ObraService.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import storageService from 'portaltransparencia-common/libs/StorageService.js';
import { FormattedCurrency } from '@elotech/components';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils';

export class ObraDetalhe extends Component {
  static propTypes = {
    obra: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    findObra: PropTypes.func.isRequired,
    medicoes: PropTypes.object.isRequired,
    empenhos: PropTypes.object.isRequired,
    findMedicoes: PropTypes.func.isRequired,
    downloadArquivo: PropTypes.func.isRequired,
    planilhas: PropTypes.object.isRequired,
    findPlanilhas: PropTypes.func.isRequired,
    findEmpenhos: PropTypes.func.isRequired,
    medicaoArquivos: PropTypes.object.isRequired,
    findArquivosMedicao: PropTypes.func.isRequired,
    fontesRecurso: PropTypes.object.isRequired,
    findFontesRecursos: PropTypes.func.isRequired,
    responsaveis: PropTypes.object,
    imoveis: PropTypes.object,
    findResponsaveis: PropTypes.func,
    findImoveis: PropTypes.func,
    paramPlanilhas: PropTypes.string,
    history: PropTypes.object,
    configGeral: PropTypes.object,
    paramExibeNumeroSEI: PropTypes.string,
    isIntegradoOxy: PropTypes.bool.isRequired,
    paramMostrarDadosImoveis: PropTypes.string
  };

  state = {
    liquidacoesLoaded: false,
    liquidacoesDocumentosLoaded: false,
    fontesRecursoLoaded: false,
    empenhosLoaded: false,
    contratos: []
  };

  componentDidMount() {
    const {
      findObra,
      location,
      findMedicoes,
      findPlanilhas,
      findOrdemArquivos,
      findResponsaveis,
      findImoveis,
      resetLiquidacoesMultipla,
      resetLiquidacoesDocumentosMultiplos,
      configGeral,
      paramMostrarDadosImoveis
    } = this.props;

    const entidade = getValueFromUrlSearchParams(location, 'entidade');
    const exercicioObra = getValueFromUrlSearchParams(
      location,
      'exercicioObra'
    );
    const idOrdemServico = getValueFromUrlSearchParams(
      location,
      'idOrdemServico'
    );
    const idOxy = getValueFromUrlSearchParams(location, 'idOxy');
    const userInfo = storageService.getItem('userInfo');

    resetLiquidacoesMultipla();
    resetLiquidacoesDocumentosMultiplos();
    if (idOxy) {
      findAllContratosByIntervencao(idOxy, userInfo?.entidade?.id).then(
        ({ data }) => {
          this.setState({ contratos: data });
        }
      );
    }
    findObra(entidade, exercicioObra, idOrdemServico, idOxy).then(
      ({ value }) => {
        findMedicoes(
          value.entidade,
          value.exercicio,
          value.idOrdemServico,
          value.idOxy
        );
        findOrdemArquivos(
          value.entidade,
          value.exercicio,
          value.idOrdemServico,
          value.idOxy
        );
        findPlanilhas(
          value.entidade,
          value.exercicio,
          value.idOrdemServico,
          value.idOxy
        );
        if (configGeral.get('isIntegradoOxy')) {
          findResponsaveis(value.idOxy);
          if (paramMostrarDadosImoveis === 'S') {
            findImoveis(value.idOxy);
          }
        }
      }
    );
  }
  buildFilterEmpenho(obra) {
    const entidade = obra.get('entidadeSiscop');
    const exercicioObra = obra.get('exercicio');
    const idOrdemObra = obra.get('idOrdembuildFilterEmpenhoServico');
    const idOxy = obra.get('idOxy');
    if (idOxy) return `?search=idOxy==${idOxy}`;
    if (!entidade) return '';
    const filter = `?search=id.entidade==${entidade} and exercicioObra==${exercicioObra} and idOrdemObra==${idOrdemObra}`;
    return filter;
  }

  getValorEmpenhado = empenhos => {
    let valorAnulacoes = 0;
    let valorEstornoAnulacoes = 0;
    let valorEmpenhado = 0;

    if (empenhos) {
      empenhos.map(empenho => {
        valorAnulacoes = empenho.get('valorAnulacoes')
          ? empenho.get('valorAnulacoes')
          : 0;
        valorEstornoAnulacoes = empenho.get('valorEstornoAnulacoes')
          ? empenho.get('valorEstornoAnulacoes')
          : 0;
        valorEmpenhado +=
          empenho.get('valor') - (valorAnulacoes - valorEstornoAnulacoes);
      });
    }

    return valorEmpenhado;
  };

  handleTabClick = tabProps => {
    const {
      obra,
      empenhos,
      findEmpenhoLiquidacoesMultipla,
      findEmpenhoLiquidacoesDocumentosMultiplos,
      findFontesRecursos,
      findEmpenhos
    } = this.props;

    if (!obra) {
      return;
    }

    const {
      liquidacoesLoaded,
      liquidacoesDocumentosLoaded,
      fontesRecursoLoaded,
      empenhosLoaded
    } = this.state;

    const loadEmpenhos = async () => {
      if (empenhosLoaded) {
        return empenhos;
      }
      return findEmpenhos(
        obra.get('entidadeSiscop'),
        obra.get('exercicio'),
        obra.get('idOrdemServico'),
        obra.get('idOxy')
      )
        .then(({ value }) => fromJS(value))
        .finally(() => this.setState({ empenhosLoaded: true }));
    };

    const pendingPromises = new Set();
    const handleEmpenhosWithFilter = async fetcher => {
      const loadedEmpenhos = await loadEmpenhos();
      for (const empenho of loadedEmpenhos) {
        if (pendingPromises.size >= 10) {
          await Promise.race(pendingPromises);
        }
        const filtro = `?search=id.entidade==${obra.get(
          'entidadeSiscop'
        )}&entidade=${obra.get('entidadeSiscop')}&exercicio=${empenho.get(
          'exercicio'
        )}&empenho=${empenho.get('numeroEmpenho')}`;
        const promise = fetcher(filtro);
        promise.finally(() => pendingPromises.delete(promise));
        pendingPromises.add(promise);
      }
      await Promise.all(pendingPromises);
    };

    if (tabProps.title === 'Empenhos' && !empenhosLoaded) {
      loadEmpenhos();
    }

    if (tabProps.title === 'Liquidações' && !liquidacoesLoaded) {
      handleEmpenhosWithFilter(findEmpenhoLiquidacoesMultipla).finally(() =>
        this.setState({ liquidacoesLoaded: true })
      );
    }

    if (
      tabProps.title === 'Documentos Liquidação' &&
      !liquidacoesDocumentosLoaded
    ) {
      handleEmpenhosWithFilter(
        findEmpenhoLiquidacoesDocumentosMultiplos
      ).finally(() => this.setState({ liquidacoesDocumentosLoaded: true }));
    }

    if (tabProps.title === 'Fontes recurso' && !fontesRecursoLoaded) {
      Promise.all([
        loadEmpenhos(),
        findFontesRecursos(
          obra.get('idOxy'),
          obra.get('entidadeSiscop'),
          obra.get('exercicio'),
          obra.get('idOrdemServico')
        )
      ]).finally(() => this.setState({ fontesRecursoLoaded: true }));
    }
  };

  montarDisplay = data => {
    if (data?.numeroContrato == null) {
      return null;
    }

    if (data?.exercicio == null) {
      return data?.numeroContrato;
    }

    return data?.numeroContrato + '/' + data?.exercicio;
  };

  renderContratos(data, userInfo) {
    const entidadeId = userInfo?.entidade?.id;
    return (
      <TableActions ref="row" data={data} key={data?.id} renderButtons={false}>
        <td>
          <Link
            href={`/portaltransparencia/${entidadeId}/contratos/detalhes?id=${data?.id}`}
          >
            {this.montarDisplay(data)}
            <em className="fa fa-external-link"></em>
          </Link>
        </td>
        <td>
          <FormattedCurrency value={data?.valorContratado} />
        </td>
        <td>{data?.nome}</td>
        <td>{NumberUtils.format(data?.percentual)}%</td>
        <td>
          <FormattedCurrency value={data?.valorAditivo} />
        </td>
      </TableActions>
    );
  }

  render() {
    const {
      obra,
      medicoes,
      downloadArquivo,
      planilhas,
      location,
      medicaoArquivos,
      findArquivosMedicao,
      paramPlanilhas,
      empenhos,
      history,
      configGeral,
      ordemArquivos,
      paramExibeNumeroSEI,
      fontesRecurso,
      responsaveis,
      imoveis,
      isIntegradoOxy,
      paramMostrarDadosImoveis
    } = this.props;

    const {
      liquidacoesLoaded,
      liquidacoesDocumentosLoaded,
      empenhosLoaded,
      fontesRecursoLoaded,
      contratos
    } = this.state;

    const descricaoObra =
      obra.get('descricaoBem') ||
      `${obra.get('ordemServico')}/${obra.get('exercicio')}`;

    const userInfo = storageService.getItem('userInfo');

    return (
      <div>
        <Helmet title={`Obras Públicas - ${descricaoObra}`} />

        <PageHeader
          location={location}
          textoDetalhe={`Obras Públicas - ${descricaoObra}`}
        />

        <BotaoImprimir />

        <CabecalhoEntidade />

        <ObraDetalheInformacao
          entidade={getValueFromUrlSearchParams(location, 'entidade')}
          exercicioObra={getValueFromUrlSearchParams(location, 'exercicioObra')}
          idOrdemServico={getValueFromUrlSearchParams(
            location,
            'idOrdemServico'
          )}
          idOxy={getValueFromUrlSearchParams(location, 'idOxy')}
          valorEmpenhado={this.getValorEmpenhado(empenhos)}
          isIntegradoOxy={configGeral.get('isIntegradoOxy')}
          paramExibeNumeroSEI={paramExibeNumeroSEI}
          hasVariosContratos={contratos?.length > 1}
          hasContratoVinculado={contratos?.length > 0}
        />

        {contratos?.length > 1 && (
          <Panel expansible={false} title="Contratos" isTable>
            <div className="panel-table-outer">
              <table className="panel-table striped fancy">
                <TableHeader empty={contratos?.length === 0}>
                  <tr>
                    <th>Número</th>
                    <th>Valor Contrato</th>
                    <th>Empresa</th>
                    <th>Percentual</th>
                    <th>Valor Aditivo</th>
                  </tr>
                </TableHeader>
                <tbody>
                  {contratos?.map(contrato =>
                    this.renderContratos(contrato, userInfo)
                  )}
                </tbody>
              </table>
            </div>
          </Panel>
        )}

        <Panel expansible={false} isTable tableResponsive>
          <Tabs scrollVisibled onTabClick={this.handleTabClick}>
            <Tab title="Acompanhamentos/Medições" active>
              <ObraDetalheMedicao
                medicoes={medicoes}
                onDownload={downloadArquivo}
                location={location}
                medicaoArquivos={medicaoArquivos}
                findArquivosMedicao={findArquivosMedicao}
                isIntegradoOxy={isIntegradoOxy}
                hasVariosContratos={contratos.length > 1}
              />
            </Tab>

            <Tab title="Empenhos">
              <h4 className="mt-xs mb-xs center">
                <b>Empenhos</b>
              </h4>
              <ObraDetalheEmpenho
                empenhos={empenhos}
                entidade={obra.get('entidadeSiscop')}
                location={location}
                history={history}
                loading={!empenhosLoaded}
              />
            </Tab>
            <Tab title="Planilhas" hide={paramPlanilhas !== 'S'}>
              <ObraDetalhePlanilha
                planilhas={planilhas}
                onDownload={downloadArquivo}
              />
            </Tab>
            <Tab title="Anexos/Cronogramas">
              <ObraOrdemServicoArquivo ordemArquivos={ordemArquivos} />
            </Tab>
            <Tab title="Fontes recurso">
              <h4 className="mt-xs mb-xs center">
                <b>Fontes recurso</b>
              </h4>
              <ObraFonteRecurso
                fontesRecurso={fontesRecurso}
                empenhos={empenhos}
                isIntegradoOxy={configGeral.get('isIntegradoOxy')}
                loading={!fontesRecursoLoaded}
              />
            </Tab>

            <Tab title="Liquidações">
              <EmpenhoDetalheLiquidacoes
                exibeEmpenho={true}
                loading={!liquidacoesLoaded}
              />
            </Tab>

            <Tab title="Documentos Liquidação">
              <EmpenhoDetalheLiquidacoesDocumentos
                exibeEmpenho={true}
                loading={!liquidacoesDocumentosLoaded}
              />
            </Tab>
            {configGeral.get('isIntegradoOxy') && (
              <Tab title="Responsáveis">
                <ObraDetalheResponsavel responsaveis={responsaveis} />
              </Tab>
            )}
            {paramMostrarDadosImoveis === 'S' && (
              <Tab
                title="Imóveis"
                renderOnlyWhenActive
                hide={!configGeral.get('isIntegradoOxy')}
              >
                <ObraDetalheImovel imoveis={imoveis} />
              </Tab>
            )}
          </Tabs>
        </Panel>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    obra: state.obra.get('obra'),
    medicoes: state.obra.get('medicoes'),
    planilhas: state.obra.get('planilhas'),
    ordemArquivos: state.obra.get('ordemArquivos'),
    medicaoArquivos: state.obra.get('medicaoArquivos'),
    empenhos: state.obra.get('empenhos'),
    fontesRecurso: state.obra.get('fontesRecurso'),
    responsaveis: state.obra.get('responsaveis'),
    imoveis: state.obra.get('imoveis'),
    configGeral: state.entidade.get('configuracoesGerais'),
    paramPlanilhas: ParametroService.getValorParametro(
      state,
      PARAM_PLANILHASOBRAS
    ),
    paramExibeNumeroSEI: ParametroService.getValorParametro(
      state,
      PARAM_EXIBE_OBRAS_NUMERO_SEI
    ),
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ]),
    paramMostrarDadosImoveis: ParametroService.getValorParametro(
      state,
      PARAM_EXIBE_DADOS_IMOVEIS_OBRAS
    )
  };
}

const allActions = {
  ...actions,
  findEmpenhoLiquidacoesMultipla,
  resetLiquidacoesMultipla,
  findEmpenhoLiquidacoesDocumentosMultiplos,
  resetLiquidacoesDocumentosMultiplos,
  downloadArquivo
};

export default connect(mapStateToProps, allActions)(ObraDetalhe);
